import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
// import { EducationService } from './education.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // List of URLs that should not have the Authorization header
  private excludedUrls: string[] = [
   'http://36.225.155.37:41205/api/v1/brain/execute',
    'http://218.172.87.41:41205/api/v1/docanalysis/upload'
  ];
  constructor() {}
  intercept(                           
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if the request URL is in the excludedUrls list
    const isExcludedUrl = this.excludedUrls.some((url) =>
      request.url.includes(url)
    );

    // If the URL is in the excluded list, clone the request without the Authorization header
    if (isExcludedUrl) {
     
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'api-key':environment.API_KEY,
          'api-secret':environment.API_SECRET,
          
        },
      });
    }

    return next.handle(request);
  }
  // getToken(){
  //   return this.educationService.tokken
  // }
}
